export const MIN_NUMBER_VALUE = 0;
export const MAX_NUMBER_VALUE = 100;
